import { H5, Paragraph } from '@/components';
import Accordion from '@/components/accordion';
import CommonBlok from '@/components/common-blok';
import React from 'react';
import * as styles from './index.module.less';
import ExpandIcon from '@/images/Icon---FAQ---Expand.svg';

const AccordionHeaderWrapper = ({ children }) => {
  return (
    <div className={styles.accordion_header_wrapper}>
      <H5>{children}</H5>
      <img src={ExpandIcon} alt="expand image" className="icon-new faq accordion expand" />
    </div>
  );
};

const AnswerWrapper = ({ children }) => {
  return <div className={styles.answer_wrapper}>{children}</div>;
};

const Faqs = () => {
  const faqList = [
    {
      question: <AccordionHeaderWrapper>文字起こしの精度はどの程度ですか？</AccordionHeaderWrapper>,
      richTextAnswer: (
        <AnswerWrapper>
          <Paragraph isWordKeepAll>
            フォーマル
            <wbr />な<wbr />
            会議
            <wbr />
            など、
            <wbr />
            整然とした
            <wbr />
            発言
            <wbr />が<wbr />
            行われる
            <wbr />
            場合
            <wbr />
            には、
            <wbr />
            認識率
            <wbr />は<wbr />
            <strong>98.86%</strong>
            <wbr />
            以上
            <wbr />と<wbr />
            なります。
            <wbr />
            ※収音
            <wbr />が<wbr />
            困難な
            <wbr />
            場合
            <wbr />
            は、
            <wbr />
            認識精度
            <wbr />に<wbr />
            影響
            <wbr />を<wbr />
            与える
            <wbr />
            可能性
            <wbr />が<wbr />
            あります。
            <wbr />
            文字起こし精度
            <wbr />を<wbr />
            向上させる
            <wbr />
            コツ
            <wbr />は<wbr />
            <a href="/how-to-improve-transcription-accuracy" target="_blank" rel="noreferrer">
              こちら
            </a>
            。
          </Paragraph>
        </AnswerWrapper>
      ),
    },
    {
      question: <AccordionHeaderWrapper>データの安全性はどのように保証されていますか？</AccordionHeaderWrapper>,
      richTextAnswer: (
        <AnswerWrapper>
          <p>
            弊社は、2022年にNottaサービスのセキュリティやプライバシー原則に関する内部統制を対象に、
            <strong>SOC2認証報告書を取得</strong>しています。SOC 2（Service Organization Control Type
            2）は、米国公認会計士協会（AICPA）が開発したサイバーセキュリティ・コンプライアンス・フレームワークです。2023年9月に
            <strong>ISMS国際標準規格「ISO27001」認証</strong>を取得しています。
          </p>
          <p>
            また、<strong>すべてのデータは日本国内に保管されます</strong>
            。さらに、データは多重暗号化されて送信・保存されるため、業務担当者も個別のユーザーデータを特定して確認することはできません。
          </p>
        </AnswerWrapper>
      ),
    },
    {
      question: <AccordionHeaderWrapper>Nottaを利用可能なユーザー数はどれくらいですか？</AccordionHeaderWrapper>,
      richTextAnswer: (
        <AnswerWrapper>
          <p>
            個人利用から団体利用まで、<strong>個人プランとビジネスプラン</strong>
            がありますので、お客様のニーズに合わせてお選びください。
          </p>
        </AnswerWrapper>
      ),
    },
    {
      question: <AccordionHeaderWrapper>どのような支払い方法が利用できますか？</AccordionHeaderWrapper>,
      richTextAnswer: (
        <AnswerWrapper>
          <p>
            JCB, VISA, Mastercard, Discover, American
            Expressクレジットカードを使ってお支払いことが可能です。クレジットカードのご利用をご希望でない場合は、銀行振り込みによる
            <a href="/request">請求書払い</a>、またはApple IDやGoogle Playでの決済（アプリ版のみ）がご利用可能です。
          </p>
        </AnswerWrapper>
      ),
    },
    {
      question: <AccordionHeaderWrapper>サポート体制はどのようになっていますか？</AccordionHeaderWrapper>,
      richTextAnswer: (
        <AnswerWrapper>
          <p>
            Nottaでは、導入から運用まで、充実したサポート体制を整えております。基本料金や機能比較、導入サポートなど、お客様の課題や活用フェーズに応じた最適なサポートサービスを、弊社の専門スタッフがご案内いたします。
          </p>
          <p>
            また、プロフェッショナルな
            <strong>運用・保守ビジネスが24時間365日体制</strong>
            で、システムおよびユーザーの情報セキュリティを維持することに努めています。
          </p>
        </AnswerWrapper>
      ),
    },
  ];

  return (
    <CommonBlok
      isNewLayout
      title="よくあるご質問"
      desc={
        <p style={{ color: '#7B838C', wordBreak: 'keep-all' }}>
          検討中
          <wbr />や
          <wbr />
          既存
          <wbr />の<wbr />
          お客様
          <wbr />の<wbr />
          よくある質問
          <wbr />と<wbr />
          回答
          <wbr />を<wbr />
          紹介
          <wbr />
          します。
          <br />
          <wbr />
          掲載
          <wbr />
          され
          <wbr />て<wbr />
          いない
          <wbr />
          質問
          <wbr />は<wbr />、<a href="/contact">お問い合わせフォーム</a>
          <wbr />や<wbr />
          <a href="mailto:support@notta.ai">メール</a>
          <wbr />で<wbr />
          お気軽
          <wbr />に<wbr />
          お問い合わせ
          <wbr />
          ください。
          <wbr />
          専門スタッフ
          <wbr />が<wbr />
          サポート
          <wbr />
          します。
        </p>
      }
      paddingBottom="0"
    >
      <div className={styles.blok_content}>
        <div className={styles.faqs_container}>
          {faqList.map((item, index) => {
            return (
              <div key={index} className={styles.faq_item}>
                <Accordion AccordionHeader={item.question}>{item.richTextAnswer}</Accordion>
              </div>
            );
          })}
        </div>
      </div>
    </CommonBlok>
  );
};
export default Faqs;
